<template>
  <div class="common-layout">
    <el-container>
      <!-- 顶部菜单 -->
      <gsheader />
      <div class="video">
        <div class="name-parent">
          <div class="name">
            <h1>你好，青春！</h1>
            <h1 class="describe">2023级青春礼纪念官网</h1>
          </div>
        </div>
        <!-- <img class="top" src="https://cdn.gusui.site/myclass/img/head_map_pc.png" alt="" srcset="" /> -->
        <!-- <iframe class="top" src="//player.bilibili.com/player.html?aid=555770254&bvid=BV1Ae4y1R7re&cid=770510583&p=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe> -->
        <!-- <video src="../video/home_video.mp4" autoplay loop class="top"></video> -->
        <!-- <video src="https://download.gusui.site/d/%E4%B8%8B%E8%BD%BD%E7%BA%BF%E8%B7%AF3%20%5B%E5%A4%A9%E7%BF%BC%E4%BA%91%E7%9B%98%E5%AE%A2%E6%88%B7%E7%AB%AF%E5%88%86%E6%B5%81%5D/%E9%9D%92%E6%98%A5%E7%A4%BC/2022/public/home_video.mp4" autoplay loop muted class="top" loading="lazy"></video> -->
        <!-- <video preload="none" poster="占位图" autoplay loop muted class="top" v-if="pc">
          <source src="../video/home_video_compressed.mp4" type="video/mp4">
        </video> -->
        <video
          src="../video/header.mp4"
          autoplay
          loop
          muted
          class="top"
          v-if="pc"
        ></video>
      </div>
      <div></div>

      <img
        class="m"
        src="../img/header.png"
        alt=""
        srcset=""
        style="width: 100vw"
        v-if="model"
      />

      <!-- 主体 -->
      <el-main>
        <center>
          <h1 id="refreshListener" style="font-size: 32px; margin-top: 50px">预览·完整回放</h1>
          <p style="margin-bottom: 32px">
            推荐从 顶部导航栏 选择 完整观看 并前往B站，享受完整功能体验
          </p>
        </center>

        <!-- <iframe src="" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"></iframe> -->
        <iframe width="100%" style="min-height:40vh;border-radius: 10px;"
                src="//player.bilibili.com/player.html?isOutside=true&aid=115474473944740&bvid=BV1WD1LBYEku&cid=33594281390&p=1&autoplay=0"
                scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"></iframe>



        <center>
          <h1 id="refreshListener" style="font-size: 32px; margin-top: 50px">预览·片尾态度曲</h1>
          <p style="margin-bottom: 32px">
            推荐从 顶部导航栏 选择 完整观看 并前往B站，享受完整功能体验
          </p>
        </center>
          <iframe width="100%" style="min-height:40vh;border-radius: 10px;"
                src="//player.bilibili.com/player.html?isOutside=true&aid=115435819303618&bvid=BV14EsZzXEWi&cid=33409073735&p=2&autoplay=0"
                scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"></iframe>

        <!-- <gscard
          url="//player.bilibili.com/player.html?isOutside=true&aid=113651092554278&bvid=BV1xxBLYREiJ&cid=27339131313&p=1&autoplay=0"
          onclick="window.open ('https://www.bilibili.com/video/BV1xxBLYREiJ/?share_source=copy_web&vd_source=cde34c7b8cbdabc72b04858cc61446dd')"
        >
          <template v-slot:title>节目回放</template>
          <template v-slot:name>入场及升旗仪式</template>
          <template v-slot:introduce
            >序章旨在为整个活动设定基调，激发参与者的热情。各班级在班主任的带领下，步入青春之门，象征着学生们正式迈入青春的旅程，现场播放青春礼主题曲《有我》；随后倒计时以及击鼓；结束后全体起立，奏唱国歌，以庄严的仪式感拉开序幕。</template
          >
          <template v-slot:actor>鼓乐成员。</template>
        </gscard> -->
        

        <center>
          <h1 id="refreshListener" style="font-size: 32px; margin-top: 50px">纪念相册</h1>
          <p style="margin-bottom: 32px">
            点击查看详情可以 查看原图、点赞 以及 查看和发送评论
          </p>
        </center>

        <div
          ref="masonry"
          v-masonry
          transition-duration="1s"
          item-selector=".masonry-tile"
          id="wfc"
        >
          <div class="masonry-tile" v-for="(item, index) in list" :key="index">
            <el-card style="width: 100%" class="box-card" @click="show(item.id)">
              <div class="image-wrapper">
                <el-image :src="item.thumbnail" style="width: 100%" lazy @load="refresh">
                  <template #placeholder>
                    <center>
                      <b><div class="image-slot">正在加载原图，请稍候...</div></b>
                    </center>
                  </template>
                </el-image>
                <div class="image-info">
                  <div class="info-item">
                    <el-icon><Picture /></el-icon>
                    <span>#{{ item.id }}</span>
                  </div>
                  <div class="info-item">
                    <el-icon><StarFilled /></el-icon>
                    <span>{{ item.like }}</span>
                  </div>
                  <div class="info-item">
                    <el-icon><ChatDotRound /></el-icon>
                    <span>{{ item.comment_count }}</span>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </div>

        <!-- 加载状态提示 -->
        <center style="margin: 30px 0;">
          <div v-if="isLoadingMore">
            <el-icon class="is-loading" style="font-size: 24px;">
              <Loading />
            </el-icon>
            <p style="margin-top: 10px; color: #909399;">正在加载更多...</p>
          </div>
          <div v-else-if="!hasMore && list.length > 0">
            <p style="color: #909399;">已经到底啦 ~</p>
          </div>
        </center>

        <el-dialog
          v-model="dialogVisible"
          :title="'详情页 #' + showData.id"
          width="500"
          align-center
          style="max-width: 100%"
        >
          <center>
            <h2>原图</h2>
            （右键或长按保存）
          </center>
          <br />
          <el-image :src="showData.src" style="width: 100%">
            <template #placeholder>
              <center>
                <b><div class="image-slot">正在加载原图，请稍候...</div></b>
              </center>
            </template>
          </el-image>
          <br /><br />
          <center>
            <h2>点赞</h2>
            <br />
            <el-button type="danger" plain :loading="isLoading" @click="like(showData.id)"
              >点赞 {{ showData.like }}</el-button
            >
            <br /><br />
            <h2>评论</h2>
            <br />
            <el-input
              v-model="input"
              style="width: 70%"
              placeholder="善语结善缘 恶语伤人心"
              show-word-limit
              maxlength="25"
            />&emsp;
            <el-button
              type="primary"
              plain
              :loading="isLoading2"
              @click="submitComment(showData.id)"
              >发布</el-button
            >
          </center>
          <br />
          <center>
            <div>
              <el-tag
                style="margin: 5px; border-radius: 10px; max-width: 100%"
                size="large"
                effect="plain"
                type="primary"
                v-for="(comment, index) in comments"
                :key="index"
                >{{ comment }}</el-tag
              >
            </div>
          </center>
        </el-dialog>

        <!-- 致谢 -->
        <!-- <el-card class="box-card thanks">
          <template #header>
            <div class="card-header">
              <span><b>鸣谢</b></span>
            </div>
          </template>
          <center>
            <h2><b>😀特别感谢所有同学的大力支持🎉</b></h2>
            <h3><b>活动策划不易，请耐心看完！</b></h3>
            <br /><br />
            <h3>策划🗒️</h3>
            <b>校长：</b>-<br /><br />

            <br /><br />
            <h3>网站💻</h3>
            <br />
            <b>美术：</b
            >3.4吕璟辰（谷穗社区工作室）、<br />3.12王梓安（唐浩轩科技）、<br />3.16曲奕霖（电视猪开发团队）<br /><br />
            <b>开发：</b>3.4吕璟辰（谷穗社区工作室）<br /><br />
            <b>部署：</b>3.4吕璟辰（谷穗社区工作室）<br /><br />
            <b>技术支持：</b>3.16曲奕霖（电视猪开发团队）<br /><br />
            <b>算力支持：</b>谷穗社区工作室、腾讯云、天翼云盘、蓝奏云<br /><br />

            <br /><br />
            <h3>后勤🛠️</h3>
            <br />
            <b>灯光：</b>3.4吕璟辰（谷穗社区工作室）<br /><br />
            <b>视频：</b>3.12王梓安（唐浩轩科技）<br /><br />
            <b>PPT：</b>3.16曲奕霖（电视猪开发团队）<br /><br />
            <b>幕布：</b>3.1 -<br /><br />
            <b>音频：</b>-<br /><br />
          </center>
        </el-card> -->
      </el-main>

      <!-- 底部 -->
      <el-footer>
        <el-card class="box-card" style="margin: 1rem;padding-left: 1rem;padding-right: 1rem;">
          <center>
            <div style="display: flex; flex-direction: column; align-items: center; width: 100%;">
              <div style="margin-bottom: 0.5em;">青春礼纪念官网</div>
              <div style="margin-bottom: 0.5em;">Copyright © 2025 谷穗社区工作室</div>
              <div style="margin-bottom: 1em;">Powered by GusuiCommunity</div>
              <table style="border-collapse: collapse; text-align: left; font-size: 0.8em; margin-bottom: 1em;">
                <tr>
                  <td colspan="2" style="padding: 0 1em 0 0; font-weight: bold;">青春礼纪念计划人员（排名不分前后）</td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 0.2em 0 0.5em 0;">4.11吕璟辰(谷穗社区工作室)、4.7王梓安(唐浩轩科技)、4.1张紫豪、4.11宫郝、4.7朱奕涵</td>
                </tr>
                <tr>
                  <td style="padding: 0 1em 0 0; font-weight: bold;">美术顾问</td>
                  <td style="padding: 0;">吕璟辰、王梓安、朱奕涵</td>
                </tr>
                <tr>
                  <td style="padding: 0 1em 0 0; font-weight: bold;">开发部署</td>
                  <td style="padding: 0;">吕璟辰</td>
                </tr>
                <tr>
                  <td style="padding: 0 1em 0 0; font-weight: bold;">技术支持</td>
                  <td style="padding: 0;">王梓安</td>
                </tr>
                <tr>
                  <td style="padding: 0 1em 0 0; font-weight: bold;">算力支持</td>
                  <td style="padding: 0;">谷穗社区工作室、腾讯云计算</td>
                </tr>
              </table>
              <div style="margin-bottom: 0.2em;">
                <a target="_blank" href="https://beian.miit.gov.cn">鲁ICP备2022032319号-3</a>
              </div>
              <div>
                <a target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch?code=37069302888890">鲁公网安备 37069302888890号</a>
              </div>
            </div>
          </center>
        </el-card>
        <br />
      </el-footer>
    </el-container>
  </div>
  <el-backtop :right="20" :bottom="20" />
</template>

<script>
import gsheader from "./header.vue";
// import gscard from "./card.vue";

// import {ref} from 'vue'

// import "vue-waterfall-plugin-next";
// import "vue-waterfall-plugin-next/dist/style.css";

// import { Waterfall, LazyImg } from 'vue-waterfall-plugin-next';
// import { inject } from 'vue'
// const $redrawVueMasonry = inject('redrawVueMasonry');

// $redrawVueMasonry();
import { ElMessage } from "element-plus";
import axios from "axios";
export default {
  name: "App",
  components: {
    gsheader,
    // gscard,
  },
  data: function () {
    return {
      user: "",
      avatar: "",
      screenWidth: document.body.clientWidth,
      model: window.matchMedia("(max-width: 768px)").matches,
      pc: window.matchMedia("(min-width: 768px)").matches,
      links: {},
      dialogVisible: false,
      isLoading: false,
      isLoading2: false,
      comments: [],
      input: "",
      showData: {
        id: NaN,
        title: "",
        description: "",
        thumbnail: "",
        src: "",
        like: 0,
      },
      list: [],
      allData: [], // 存储全部数据
      displayCount: 30, // 初始显示15条
      pageSize: 5, // 每次加载15条
      isLoadingMore: false, // 是否正在加载更多
      hasMore: true, // 是否还有更多数据
    };
  },
  mounted() {
    const _this = this;
    window.addEventListener("resize", () => {
      _this.screenWidth = document.body.clientWidth;
    });

    // 添加滚动监听
    window.addEventListener("scroll", this.handleScroll);

    setTimeout(() => {
      this.$redrawVueMasonry();
    }, 1000);

    axios.defaults.withCredentials = false;
    axios
      .get("https://qcl_api.gusui.site/2023.php")
      .then((response) => {
        if (response.data.message != null) {
          ElMessage({
            message: "拉取相册列表失败（数据层）！错误代码：" + response.data.message,
            type: "error",
          });
        } else {
          this.allData = response.data; // 存储全部数据
          this.list = this.allData.slice(0, this.displayCount); // 只显示前15条
          this.hasMore = this.displayCount < this.allData.length;
        }
      })
      .catch(function (error) {
        ElMessage({
          message: "拉取相册列表失败（网络层）！错误代码：" + error,
          type: "error",
        });
      });
  },
  beforeUnmount() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    refresh() {
      this.$redrawVueMasonry();
    },
    handleScroll() {
      // 节流处理，避免频繁触发
      if (this.isLoadingMore || !this.hasMore) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // 当滚动到距离底部200px时开始加载
      if (scrollTop + windowHeight >= documentHeight - 200) {
        this.loadMore();
      }
    },
    loadMore() {
      if (this.isLoadingMore || !this.hasMore) return;

      this.isLoadingMore = true;
      
      // 模拟加载延迟，让用户看到加载状态
      setTimeout(() => {
        const currentLength = this.list.length;
        const newDisplayCount = currentLength + this.pageSize;
        const newItems = this.allData.slice(currentLength, newDisplayCount);
        
        if (newItems.length > 0) {
          this.list = this.list.concat(newItems);
          this.displayCount = newDisplayCount;
          
          // 检查是否还有更多数据
          this.hasMore = this.displayCount < this.allData.length;
          
          // 重新布局瀑布流
          this.$nextTick(() => {
            this.$redrawVueMasonry();
          });
        } else {
          this.hasMore = false;
        }
        
        this.isLoadingMore = false;
      }, 300);
    },
    show(id) {
      const item = this.list.find((n) => n.id === id);
      if (item) {
        this.showData = item;
        console.log(this.showData);
        this.dialogVisible = true;
        this.getComments(id);
      } else {
        ElMessage({
          message: "获取ID并回调时出现错误！",
          type: "error",
        });
      }
    },
    like(id) {
      this.isLoading = true;
      axios
        .get("https://qcl_api.gusui.site/2023_like.php?id=" + id)
        .then((response) => {
          if (response.data.message === "点赞成功") {
            // if (typeof this.showData.like === "string") {
            //   this.showData.like = parseInt(this.showData.like, 10);
            // }
            // this.showData.like += 1;

            // 更新list中指定id的like
            const index = this.list.findIndex((item) => item.id === id);
            if (index !== -1) {
              if (typeof this.list[index].like === "string") {
                this.list[index].like = parseInt(this.list[index].like, 10);
              }
              this.list[index].like += 1;
              ElMessage({
                message: "点赞成功！",
                type: "success",
              });
            } else {
              ElMessage({
                message: "点赞已提交但更新列表失败！",
                type: "error",
              });
            }
          } else if (response.data.message === "点赞失败") {
            ElMessage({
              message: "点赞失败！",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          ElMessage({
            message: "点赞失败（网络层）！错误代码：" + error,
            type: "error",
          });
        })
        .finally(() => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
    },
    getComments(id) {
      axios
        .get(`https://qcl_api.gusui.site/2023_comment.php?id=${id}&action=get`) // 假设这是获取评论的API
        .then((response) => {
          if (response.data.message != null) {
            ElMessage({
              message: "拉取评论列表失败（数据层）！错误代码：" + response.data.message,
              type: "error",
            });
          } else {
            this.comments = response.data.comments; // 假设返回的评论列表直接赋值给this.comments
            this.input = "";
          }
        })
        .catch(function (error) {
          ElMessage({
            message: "拉取评论列表失败（网络层）！错误代码：" + error,
            type: "error",
          });
        });
    },
    submitComment(id) {
      this.isLoading2 = true;
      axios
        .post(
          `https://qcl_api.gusui.site/2023_comment.php?action=add`,
          {
            id: id,
            comment: this.input,
          },
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((response) => {
          if (response.data.message === "评论添加成功") {
            ElMessage({
              message: "评论成功！",
              type: "success",
            });
            // 重新获取评论列表
            this.getComments(id);
          } else {
            ElMessage({
              message: "评论失败！",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          ElMessage({
            message: "评论失败（网络层）！错误代码：" + error,
            type: "error",
          });
        })
        .finally(() => {
          setTimeout(() => {
            this.isLoading2 = false;
          }, 500);
        });
    },
  },
  watch: {
    screenWidth() {
      if (!this.timer) {
        this.timer = true;
        setTimeout(() => {
          // 根据新的窗口宽度调整布局
          this.model = window.matchMedia("(max-width: 768px)").matches;
          this.pc = window.matchMedia("(min-width: 768px)").matches;
          this.timer = false;
        }, 400);
      }
    },
  },
};
</script>
